module.exports = __webpack_public_path__ + "static/media/Introdução.0ff9bdb8.webp";